import {
  ComponentConfig,
  LayoutTypes,
  ComponentType,
  FlexDirection,
  ActionType,
} from "../services/types/ComponentTypes";

export const screen_104_job_card: ComponentConfig[] = [
  {
    componentType: LayoutTypes.SCREEN_GROUP,
    title: "Job card",
    style: {
      backgroundColor: "#F9FAFB", // bg-gray-50 from design system
    },
    childComponents: [
      {
        componentType: LayoutTypes.GROUP,
        style: {
          backgroundColor: "#ffffff",
          direction: FlexDirection.COLUMN,
          borderRadius: 12, // Design system: rounded-lg (12px)
          padding: 16, // Design system: p-4 (16px)
        },
        childComponents: [
          {
            componentType: ComponentType.SUMMARY_LIST,
            titleValue: "jobcard_no",
            Name: "jobcard_summary",
            SummeryActions: [
              {
                ActionType: ActionType.MANPOWER_ALLOCATION,
                Action: {
                  Action: "manpower_allocation",
                },
                tooltip: "Assign employees",
              },
              {
                ActionType: ActionType.VIEW_REPORT,
                Action: {
                  Action: "Report",
                  Api: "job_card_summary_details",
                },
                tooltip: "View Report",
              },
              {
                ActionType: ActionType.PDF_DOWNLOAD,
                Action: {
                  Action: "PDF",
                  Settings: "job_card_summary_details",
                },
                tooltip: "Download PDF",
              },
            ],
            Form: {
              Name: "jobcard_summary",
              TableName: "service_job_card",
              View: "view_jobcard_summary",
              Filter:
                "view_jobcard_summary.soft_delete=0 order by view_jobcard_summary.created_at desc",
              Fields: [
                {
                  IncludeLabel: true,
                  Label: "Job date",
                  IsMandatory: false,
                  BindValue: "txt_date",
                  Json_Attribute: "job_date",
                  componentType: ComponentType.DATE_FIELD,
                  showInSummary: true,
                },
                {
                  IncludeLabel: true,
                  Label: "Jobcard No.",
                  BindValue: "txt_est",
                  Json_Attribute: "jobcard_no",
                  componentType: ComponentType.TEXT_FIELD,
                  showInSummary: true,
                },
                {
                  IncludeLabel: true,
                  Label: "Vehicle make",
                  BindValue: "txt_vehiclemake",
                  Json_Attribute: "vehicle_make",
                  componentType: ComponentType.TEXT_FIELD,
                  showInSummary: true,
                },
                {
                  IncludeLabel: true,
                  Label: "Reg No.",
                  BindValue: "txt_regno",
                  Json_Attribute: "reg_no",
                  componentType: ComponentType.TEXT_FIELD,
                  showInSummary: true,
                },
                {
                  IncludeLabel: true,
                  Label: "Customer name",
                  BindValue: "txt_vehiclemake",
                  Json_Attribute: "customer_name",
                  componentType: ComponentType.TEXT_FIELD,
                  showInSummary: true,
                },
                {
                  IncludeLabel: true,
                  Label: "Address",
                  BindValue: "txt_address",
                  Json_Attribute: "address",
                  componentType: ComponentType.TEXT_FIELD,
                  showInSummary: true,
                },
                {
                  IncludeLabel: true,
                  Label: "Phone",
                  BindValue: "txt_phone",
                  Json_Attribute: "phone",
                  componentType: ComponentType.TEXT_FIELD,
                  showInSummary: true,
                },
                {
                  IncludeLabel: true,
                  Label: "Manpower status",
                  BindValue: "txt_manpower_status",
                  Json_Attribute: "manpower_status",
                  componentType: ComponentType.TEXT_FIELD,
                  showInSummary: true,
                },
                {
                  IncludeLabel: true,
                  Label: "Invoice status",
                  BindValue: "txt_invoice_status",
                  Json_Attribute: "invoice_status",
                  componentType: ComponentType.TEXT_FIELD,
                  showInSummary: true,
                },
              ],
            },

            // dataArray: [
            //   {
            //     reg_no: "678590",
            //     vehiclemake: "HYUNDAI",
            //     vehicletype: "VERNA",
            //     model_year: "2018",
            //     customer_id: "Rukma V S",
            //     engine_no: "947464749",
            //     chasis_no: "84647484764",
            //     last_status: "Parts issue",
            //   },
            //   {
            //     reg_no: "X9045",
            //     vehiclemake: "BENTLEY",
            //     vehicletype: "Luxury SUV",
            //     model_year: "Genesis GV80",
            //     customer_id: "Demo cust",
            //     engine_no: "G4KID123456",
            //     chasis_no: "MAITA2BCMI234567",
            //     last_status: "Job card",
            //   },
            //   {
            //     reg_no: "2845 DXB H",
            //     vehiclemake: "MITSUBISHI",
            //     vehicletype: "CANTER",
            //     model_year: "2022",
            //     customer_id: "A LIUSIE",
            //     engine_no: "",
            //     chasis_no: "HJGADGAJH556",
            //     last_status: "Estimation",
            //   },
            //   {
            //     reg_no: "10001 DXB O",
            //     vehiclemake: "MITSUBISHI",
            //     vehicletype: "PAJERO",
            //     model_year: "2000",
            //     customer_id: "IRFAN",
            //     engine_no: "",
            //     chasis_no: "XXXXXXXXXXXXX",
            //     last_status: "Invoice",
            //   },
            // ],
          },
        ],
      },
    ],
  },
];
